import * as DOMPurify from 'dompurify';

/**
 * Handy multi-language-safe slugify.
 * Courtesy of https://gist.github.com/max10rogerio/c67c5d2d7a3ce714c4bc0c114a3ddc6e
 */
export const slugify = (...args: (string | number)[]): string => {
	const value = args.join(' ');
	return value
		.normalize('NFD') // split an accented letter in the base letter and the acent
		.replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
		.replace(/\s+/g, '-'); // separator
};

const purify = DOMPurify();

/**
 * XSS protection.
 * @param html HTML string
 */
export const purifyHTML = (html: string): string => purify.sanitize(
	html,
	{ USE_PROFILES: { html: true } },
);

export default purifyHTML;
